import { buildApplicationFeedbackItems } from "../../utils/sourceChangeApplicationFeedback.js";

const keepUnitsTogether = (value) => value.replace(/\b\d+(?:[.,]\d+)?\s+(?:h(?:\s+\d{1,2}(?!\d))?|min|t)\b/g,
  (unit) => unit.replace(/\s/g, "\u00a0"));

export default function SourceChangeApplicationFeedback({ feedback, diagnostics = [], fallbackDiagnostics = [], role = "status" }) {
  const items = buildApplicationFeedbackItems(feedback, { diagnostics, fallbackDiagnostics });
  if (!items.length) return null;
  return (
    <div className="grid min-w-0 gap-1 rounded-[4px] border border-black/25 bg-[rgba(255,250,242,0.92)] p-2 text-[0.66rem] leading-4 text-slate-600 whitespace-normal [overflow-wrap:anywhere]"
      role={role} data-source-change-application-feedback={feedback?.kind || "fallback"}>
      {items.map((item, index) => (
        <p key={`${item.reasonCode}|${index}`} className="m-0">
          {keepUnitsTogether([item.message, item.resolutionMessage !== item.message ? item.resolutionMessage : ""].filter(Boolean).join(" "))}
        </p>
      ))}
    </div>
  );
}
